// extracted by mini-css-extract-plugin
module.exports = {"playBox":"playBox___3Kv1x"};